import AllUsers from '@/app/all-users'
import { ability } from '@/casl/ability'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import { createFileRoute, redirect } from '@tanstack/react-router'

const RouteComponent = () => {
  return <AllUsers />
}

export const Route = createFileRoute('/_auth/all-users')({
  beforeLoad: ({ context }) => {
    if (
      ability &&
      context.auth.user &&
      !ability.can('read', 'Tüm Kullanıcılar')
    ) {
      // toast.error("Bu sayfayı görüntüleme izniniz yok.")
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  component: RouteComponent,
})

